var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-557 558.8 84.3 84.2",
    style: {
      enableBackground: "new -557 558.8 84.3 84.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-back-button{fill:#666666;}\n\t.st1-back-button{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.15445839351353, 42.1202761920784) scale(-1, 1) translate(-42.15445839351353, -42.1202761920784)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "st0-back-button",
    d: "M568.9,599.8c0,16.6,13.6,30.2,30.2,30.2c16.6,0,30.2-13.6,30.2-30.2s-13.6-30.2-30.2-30.2 C582.5,569.6,568.9,583.2,568.9,599.8l30.2,27.2c15,0,27.2-12.2,27.2-27.2s-12.2-27.2-27.2-27.2c-15,0-27.2,12.2-27.2,27.2 s12.2,27.2,27.2,27.2L568.9,599.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st0-back-button",
    d: "M599.1,559.8c22,0,40,18,40,40s-18,40-40,40c-22,0-40-18-40-40S577.1,559.8,599.1,559.8v79 c21.4,0,39-17.4,39-39c0-21.4-17.6-39-39-39c-21.4,0-39,17.6-39,39s17.4,39,39,39V559.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.15445839351352, 42.1202761920784) rotate(150.00005363462506) translate(-42.15445839351352, -42.1202761920784)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "st1-back-button",
    d: "M-130.5-719.3c0-17-13.8-30.8-30.8-30.8v4c14.6,0,26.6,12,26.6,26.6c0,14.6-12,26.6-26.6,26.6 s-26.6-12-26.6-26.6c0-2.4,0.2-5,1-7.4l-4.2-1.2c-0.8,3-1.2,5.8-1.2,8.8c0,17,13.8,30.8,30.8,30.8 C-144.5-688.5-130.5-702.3-130.5-719.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "st1-back-button",
    d: "M607.2,590.8l1.1-1.1c0.4-0.4,1.2-0.4,1.6,0l9.2,9.3c0.4,0.4,0.4,1.2,0,1.6l-9.2,9.3 c-0.4,0.4-1.2,0.4-1.6,0l-1.1-1.1c-0.5-0.5-0.4-1.2,0-1.6l5.7-5.5h-32.8c-0.6,0-1.1-0.5-1.1-1.1V599c0-0.6,0.5-1.1,1.1-1.1H613 l-5.7-5.5C606.8,591.9,606.8,591.2,607.2,590.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c047682d2ab0a69db594328047937ae1.svg";
export { ForwardRef as ReactComponent };